import { Link } from 'react-router';
import { Money } from '../../../ui';
import { spokenPeso } from '../../../ui/spokenPeso';
import { copy } from '../copy';
import { duePaydaysOf, liveSources, nextPaydayOf } from '../derive';
import { dayShort, daysAwayText, spokenDate } from '../format';
import { useBudgetToday } from '../hooks';
import { ACCENT_LINK, FOCUS, LABEL } from '../styles';

export function NextPaydayTile() {
  const s = useBudgetToday();
  if (!s) return <p className="text-sm text-muted">{copy.loading}</p>;

  if (liveSources(s).length === 0) {
    return (
      <div
        role="group"
        aria-label={`${copy.nextPayday}, ${copy.noSources}`}
        className="flex flex-col gap-2"
      >
        <p className="text-sm text-muted">{copy.noSources}</p>
        <Link to="/m/budget/income/new?kind=salary" className={ACCENT_LINK}>
          {copy.addSalary}
        </Link>
      </div>
    );
  }

  const due = duePaydaysOf(s)[0];
  if (due) {
    return (
      <div
        role="group"
        aria-label={`${copy.paydayQuestion(due.defaultAmountMinor)} ${due.sourceName}, ${spokenDate(due.date)}`}
        className="flex flex-col gap-2"
      >
        <p className="text-fg">{copy.paydayQuestion(due.defaultAmountMinor)}</p>
        <p className="text-sm text-muted">
          {due.sourceName} · {dayShort(due.date)}
        </p>
        <Link to={`/m/budget/payday/${due.sourceId}/${due.nominalDate}`} className={ACCENT_LINK}>
          {copy.answer}
        </Link>
      </div>
    );
  }

  const next = nextPaydayOf(s);
  if (!next) return <p className="text-sm text-muted">{copy.nothingHere}</p>;
  return (
    <div
      role="group"
      aria-label={`${copy.nextPayday}, ${spokenDate(next.date)}, ${spokenPeso(next.defaultAmountMinor)}`}
      className="flex flex-col gap-1"
    >
      <Link to="/m/budget/income" className={`inline-flex min-h-11 items-center ${LABEL} ${FOCUS}`}>
        {next.sourceName}
      </Link>
      <Money
        minor={next.defaultAmountMinor}
        cents="auto"
        className="block text-[26px] leading-tight"
      />
      <p className="text-sm text-muted">
        {dayShort(next.date)} · {daysAwayText(s.today, next.date)}
      </p>
    </div>
  );
}
